(function() { window.GUID_335ba145_cecb_488f_af8a_62b4907ccde1 = { getGuid: function() { return "335ba145-cecb-488f-af8a-62b4907ccde1"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        class General {
        }
        Views.General = General;
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=general.js.map
